const faqs = document.querySelectorAll(".adm-div-c68-faq-title-container");

const faqContainer = document.querySelector('.adm-div-c68-faqs-container');

const stickyNav = document.querySelector('.adm-c69-sticky-nav-container');

function initializeFaqs() {
    faqs.forEach((faq) => {
        faq.addEventListener("click", () => {
            const parent = faq.parentElement;
            const imageContainer = parent.querySelector('.adm-div-c68-faq-image-container');
            const linksContainer = parent.querySelector('.adm-div-c68-faq-links-container');

            if (imageContainer.querySelector('img')) {
                // Intentionally left blank
            } else if (linksContainer) {
                const liElements = linksContainer.querySelectorAll('li');
                imageContainer.style.width = '0%';
                linksContainer.style.width = '100%';
                linksContainer.style.marginBottom = '30px';
                setTimeout(() => {
                    liElements.forEach(li => li.style.marginLeft = '0px');
                }, 500);
            }

            if (parent.classList.contains("active")) {
                // DE-ACTIVATE FAQ
                parent.classList.remove("active");

                if (stickyNav && window.innerWidth > 1200) {
                    // DESKTOP
                    // WHEN DEACTIVATING FAQ, FOCUS ON FAQ CONTAINER.
                    // OFFSET THE SCROLL BY THE HEIGHT OF STICKY NAVIGATION (76px), NAVBAR (75px), AND UTILITY BAR (36px).
                    const offset = faqContainer.getBoundingClientRect().top + window.scrollY - 187;
                    window.scrollTo({
                        top: offset,
                        behavior: 'smooth'
                    });
                } else if (!stickyNav && window.innerWidth > 1200) {
                    // DESKTOP & NO STICKY NAVIGATION
                    // WHEN DEACTIVATING FAQ, FOCUS ON FAQ CONTAINER OFFSET BY NAVBAR + UTILITY BAR HEIGHT.
                    const offset = faqContainer.getBoundingClientRect().top + window.scrollY - 111;
                    window.scrollTo({
                        top: offset,
                        behavior: 'smooth'
                    });
                } else if (stickyNav && window.innerWidth <= 1200) {
                    // MOBILE
                    // OFFSET THE SCROLL BY THE HEIGHT OF STICKY NAVIGATION (74px), MOBILE NAV (72px).
                    const offset = faqContainer.getBoundingClientRect().top + window.scrollY - 146;
                    window.scrollTo({
                        top: offset,
                        behavior: 'smooth'
                    });
                } else if (!stickyNav && window.innerWidth <= 1200) {
                    // MOBILE & NO STICKY NAVIGATION
                    // OFFSET THE SCROLL BY THE HEIGHT OF MOBILE NAV (72px).
                    const offset = faqContainer.getBoundingClientRect().top + window.scrollY - 72;
                    window.scrollTo({
                        top: offset,
                        behavior: 'smooth'
                    });
                }
            } else if ( !parent.classList.contains("active")) {
                // ACTIVATE FAQ
                parent.classList.add("active");
                // SCROLL TO THE FAQ
                if (stickyNav) {
                    // OFFSET THE SCROLL BY THE HEIGHT OF STICKY NAVIGATION (74px).
                    const offset = faq.getBoundingClientRect().top + window.scrollY - 74;
                    window.scrollTo({
                        top: offset,
                        behavior: 'smooth'
                    });
                } else if (!stickyNav) {
                    const offset = faq.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                        top: offset,
                        behavior: 'smooth'
                    });
                }
            }

        });
    });
    
    faqs[0].parentElement.classList.add("active");
}

document.addEventListener("DOMContentLoaded", initializeFaqs());